import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;
export const Status = styled.span`
  font-size: 5rem;
  font-weight: 800;
  line-height: 125%;
  letter-spacing: -0.06em;
  color: #e5e5e5;
`;

export const Message = styled.span`
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #595959;
`;

export const ErrorMessageWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;
  white-space: nowrap;
`;

export const ContentWrap = styled.div`
  width: 334px;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    white-space: pre-wrap;
    font-size: 1rem;
    font-weight: 400;
    line-height: 160%;
    letter-spacing: -0.03em;
    color: #999999;
  }
`;
